var dede = {
	"coupon-callout": {
	"coupon-code": "Code",
	"coupon-message-with-price": "Nur {{ price }}",
	"coupon-expiry-message": "Gültig bis {{ Date }}.",
	"code-at-checkout": "Code an der Kasse eingeben. Kann nicht mit anderen Angebotscodes, Angeboten oder Rabatten kombiniert werden.",
	"cancel-icon": "Abbrechen",
	"info-icon": "Details ansehen",
	"check-icon": "Angewendet",
	"promo-code": "Angebotscode",
	"coupon-callout-popover": "Pop-up-Callout für Gutschein"
}
};

export { dede as default };
//# sourceMappingURL=src-localization-texts-de-de.json.js.map
